export class ProfileService {
  constructor($resource, ApiService) {
    "ngInject";

    this.$resource = $resource;
    this.apiService = ApiService;
  }
  getProfileDetailsResource(id) {
    const _accountId = parseInt(id);
    const profileDetailsUrl = this.apiService.getResourceUrl(
      `/account/profile/${_accountId}`
    );
    return this.$resource(profileDetailsUrl, null, {
      update: {
        method: "put",
      },
    });
  }
  getProfileUpdateResource() {
    const profileUpdateUrl = this.apiService.getResourceUrl("/account/profile");
    return this.$resource(profileUpdateUrl, null, {
      update: {
        method: "put",
      },
    });
  }
  getProfileDetailsById(id) {
    const profileDetailsResource = this.getProfileDetailsResource(id);
    const promise = profileDetailsResource.get().$promise;
    return promise
      .then(({ details }) => details)
      .catch((error) => {
        throw this.apiService.getErrorMessage(error);
      });
  }
  updateProfileDetails(details) {
    const profileUpdateResource = this.getProfileUpdateResource(
      details.accountId
    );
    const promise = profileUpdateResource.update(details).$promise;
    return promise
      .then(({ details }) => details)
      .catch((error) => {
        throw this.apiService.getErrorMessage(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/profile/profile.service.js